import i18n from '@/i18n/i18n'
import { SETTINGS_PRICES_LIST_ROUTE } from '@/router/routes/settings/rates.routes'

export const SETTINGS_CARRIERS_ROUTE = 'carriers'
export const SETTINGS_CARRIERS_LIST_ROUTE = 'carriers.list'
export const SETTINGS_CARRIERS_NEW_LIST_ROUTE = 'carriers-new.list'
export const SETTINGS_CONTRACTS_LIST_ROUTE = 'contracts.list'
export const SETTINGS_CONTRACTS_SELECT_CARRIER_ROUTE = 'contracts.select_carrier'
export const SETTINGS_CONTRACTS_CONFIGURE_ROUTE = 'contracts.configure'
export const SETTINGS_CONTRACTS_REGISTER_ROUTE = 'contracts.register'
export const SETTINGS_CONTRACTS_REGISTER_SUBBROKER_ROUTE = 'contracts.register.subbroker'
const SETTINGS_CARRIERS_PRICE_LIST_ROUTE = 'prices.list'

export default {
  name: SETTINGS_CARRIERS_ROUTE,
  path: 'carriers',
  component: () => import('@/app/settings/carriers-and-prices/views/CarrierNav.vue'),
  redirect: { name: SETTINGS_CARRIERS_LIST_ROUTE },
  children: [
    {
      name: SETTINGS_CARRIERS_LIST_ROUTE,
      path: 'list',
      component: () => import('@/app/settings/carriers-and-prices/views/CarrierSelection.vue'),
      meta: {
        pageTitle: () => i18n.t('Carriers'),
        permissions: ['configure_shipping'],
      },
    },
    {
      name: SETTINGS_CARRIERS_NEW_LIST_ROUTE,
      path: 'list-new',
      component: () => import('@/app/settings/carriers-and-prices/new-version/CarrierList.vue'),
      meta: {
        pageTitle: () => i18n.t('Carriers'),
        permissions: ['configure_shipping'],
      },
    },
    {
      name: SETTINGS_CONTRACTS_LIST_ROUTE,
      path: 'contracts/list',
      component: () => import('@/app/settings/carriers-and-prices/views/ContractsList.vue'),
      meta: {
        pageTitle: () => i18n.t('Carriers'),
        permissions: ['configure_shipping'],
      },
    },
    {
      name: SETTINGS_CONTRACTS_SELECT_CARRIER_ROUTE,
      path: 'contracts/carrier/select',
      component: () => import('@/app/settings/carriers-and-prices/views/CarrierContractsList.vue'),
      meta: {
        pageTitle: () => i18n.t('Carriers'),
        permissions: ['configure_shipping'],
      },
    },
    {
      name: SETTINGS_CONTRACTS_CONFIGURE_ROUTE,
      path: 'contracts/carrier/:carrierId/configure/:contractId?',
      component: () => import('@/app/settings/carriers-and-prices/views/CarrierContractForm.vue'),
      props: route => ({
        carrierId: Number.parseInt(route.params.carrierId),
        contractId: route.params.contractId && Number.parseInt(route.params.contractId),
      }),
      meta: {
        pageTitle: () => i18n.t('Carriers'),
        permissions: ['configure_shipping'],
      },
    },
    {
      name: SETTINGS_CONTRACTS_REGISTER_SUBBROKER_ROUTE,
      path: 'contracts/carrier/:carrierCode/register-subbroker',
      component: () => import('@/app/settings/carriers-and-prices/views/CarrierContractRegisterSubbrokerForm.vue'),
      props: route => ({
        carrierCode: route.params.carrierCode,
      }),
      meta: {
        pageTitle: () => i18n.t('Carriers'),
        permissions: ['configure_shipping'],
      },
    },
    {
      name: SETTINGS_CONTRACTS_REGISTER_ROUTE,
      path: 'contracts/carrier/:carrierId/register/:carrierCode?',
      component: () => import('@/app/settings/carriers-and-prices/views/CarrierContractRegisterForm.vue'),
      props: route => ({
        carrierId: Number.parseInt(route.params.carrierId),
        contractId: route.params.contractId && Number.parseInt(route.params.contractId),
        carrierCode: route.params.carrierCode,
      }),
      meta: {
        pageTitle: () => i18n.t('Carriers'),
        permissions: ['configure_shipping'],
      },
    },
    {
      name: SETTINGS_CARRIERS_PRICE_LIST_ROUTE,
      path: 'prices/list',
      redirect: { name: SETTINGS_PRICES_LIST_ROUTE },
      meta: {
        pageTitle: () => i18n.t('Price list'),
        permissions: ['view_prices'],
      },
    },
  ],
}
